import { pluralize } from "utils/pluralize";
import type { ReviewCounts } from "v2/types/extractionReview.types";
import { reviewProgress } from "v2/utils/reviewProgress";

type ReviewProgressSummaryProps = {
  counts?: ReviewCounts;
};

export const ReviewProgressSummary = ({
  counts,
}: ReviewProgressSummaryProps) => {
  const { percent } = reviewProgress(counts);
  const conflicting = counts?.conflicting ?? 0;
  const remaining = counts?.review_remaining ?? 0;

  return (
    <div className="t-flex t-flex-col t-gap-1.5 t-rounded-xl t-border t-border-solid t-border-neutral-10 t-bg-neutral-66 t-p-5 sm:t-p-4">
      <div className="t-text-subtitle-lg t-text-text-60">
        Review &amp; confirm information
      </div>
      <div className="t-flex t-flex-col t-gap-4">
        <p className="t-m-0 t-text-body t-text-neutral-50">
          We pre-filled these from your uploaded documents. Confirm each value,
          or correct it before it&apos;s added to your profile.
        </p>
        <div className="t-h-2 t-w-full t-overflow-hidden t-rounded-lg t-bg-neutral-10 t-shadow-progress-inset">
          <div
            className="t-h-full t-rounded-lg t-bg-purple-40 t-transition-[width] t-duration-500 t-ease-in-out"
            style={{ width: `${percent}%` }}
          />
        </div>
        <div className="t-flex t-items-center t-gap-4 t-text-body-sm t-text-text-60">
          <span className="t-flex t-items-center t-gap-1">
            <span className="t-h-1.5 t-w-1.5 t-rounded-full t-bg-red" />
            {pluralize(conflicting, "Conflicting value", "Conflicting values")}
          </span>
          <span className="t-h-3 t-w-px t-bg-neutral-10" />
          <span className="t-flex t-items-center t-gap-1">
            <span className="t-h-1.5 t-w-1.5 t-rounded-full t-bg-orange-70" />
            {pluralize(remaining, "field to review", "fields to review")}
          </span>
        </div>
      </div>
    </div>
  );
};
